<template>
  <div class="container page account-setting-page password-setting-page transaction-password-page">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <div class="wrapper">
        <div class="setting-hero">
          <div class="setting-hero-icon"><van-icon name="shield-o" /></div>
          <div>
            <div class="setting-kicker">Payment security</div>
            <h1>{{$t('setting.set_money_pwd')}}</h1>
            <p>Create a four-digit PIN used only to authorize transactions.</p>
          </div>
        </div>
        <div class="item">
            <p class="title">{{$t("setting.money_place")}}</p>
            <!-- 移动端使用密码键盘 -->
            <template v-if="isMobile">
              <van-password-input
                  :value="opw"
                  :length="4"
                  :gutter="10"
                  :focused="oshowKeyboard"
                  @focus="oshowKeyboard = true;tshowKeyboard = false;"
              />
              <van-number-keyboard
                  v-model="opw"
                  :show="oshowKeyboard"
                  @input ="handleOpwInput"
                  @blur="oshowKeyboard = false"
              />
            </template>
            <!-- PC端使用普通输入框 -->
            <template v-else>
              <div class="pc-password-input">
                <input 
                  v-model="opw"
                  type="password"
                  maxlength="4"
                  class="pc-input"
                  placeholder="Please enter a 4-digit password."
                  @input="handlePcOpwInput"
                />
              </div>
            </template>
        </div>
        <div class="item">
        <p class="title">{{$t("setting.money_again_place")}}</p>
        <!-- 移动端使用密码键盘 -->
        <template v-if="isMobile">
          <van-password-input
              :value="tpw"
              :length="4"
              :gutter="10"
              :focused="tshowKeyboard"
              @focus="tshowKeyboard = true;oshowKeyboard=false;"
          />
          <van-number-keyboard
              v-model="tpw"
              :show="tshowKeyboard"
              @input ="handleTpwInput"
              @blur="tshowKeyboard = false"
          />
        </template>
        <!-- PC端使用普通输入框 -->
        <template v-else>
          <div class="pc-password-input">
            <input 
              v-model="tpw"
              type="password"
              maxlength="4"
              class="pc-input"
              placeholder="Please enter your 4-digit password again."
            />
          </div>
        </template>
        </div>
        <p class="setting-note"><van-icon name="lock" /> Never share this transaction PIN with anyone.</p>
        <van-button class="sub-btn settings-primary-button" type="primary" @click="setPayPassword()">{{$t("reservation.submit")}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo:{},
      from:'',
      isMobile: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    handlePcOpwInput() {
      // PC端输入限制为数字
      this.opw = this.opw.replace(/[^0-9]/g, '').slice(0, 4);
    },
    handleOpwInput() {
      if(this.opw.length !== 3) {
        this.oshowKeyboard = true;
        this.tshowKeyboard = false;
      } else {
        this.oshowKeyboard = false;
        this.tshowKeyboard = true;
      }
    },
    handleTpwInput() {
      if(this.tpw.length !== 3) {
        this.tshowKeyboard = true;
        this.oshowKeyboard = false;
      } else {
        this.tshowKeyboard = false;
        this.oshowKeyboard = false;
      }
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if(this.opw.length !== 4){
        this.oshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.tpw.length !== 4){
        this.tshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.opw !== this.tpw){
        this.$toast(this.$t("setting.prefect"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        }).then(res=>{
          if(res.code === 200){
            setTimeout(() => {
              this.$toast(res.msg);
            }, 500);
            if (this.from && this.from != '') {
              let from = this.from.split(":");
              console.log(from);
              if (from.length == 2) {
                this.$router.push(from[0]+"?from="+from[1]);
              } else if(from.length == 1) {
                this.$router.push(from[0]);
              }
            }
            else this.$router.push("Mine")
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.from = this.$route.query.from;
    // 检测是否为移动设备
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 0.4rem 0;
  line-height: 0.2rem;
  font-size: 0.3rem;
  font-weight: 500;
  color: #000;
  text-align: center;
}
::v-deep .van-password-input{
  width: 80%;
  height: 1.5rem;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 0.3rem;
  line-height: 0.3rem;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 1.3rem;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 0.3rem;
}
.van-password-input__security i {
  width: 0.25rem;
  height: 0.25rem;
}
::v-deep .van-key {
  height: 1rem;
  font-size: 0.55rem;
  line-height: 0.2rem;
  border-radius: 0.2rem;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 0.3rem;
  background-color: #f2f3f5;
}
::v-deep .van-key__collapse-icon {
   width: 0.5rem;
   height: 0.5rem;
 }
::v-deep .van-key__delete-icon {
  width: 0.5rem;
  height: 0.5rem;
}
.container .wrapper .sub-btn{
  margin: 1.33333rem 0 0 10%;
  width: 80%;
  height: 1.17333rem;
  border-radius: 1.06667rem;
  color: #fff;
  background: #cacaca;
  border: 0;
  background: linear-gradient(270deg, #5b60df, #5b60df);
  font-size: 0.6rem;
}
.pc-password-input {
  width: 80%;
  margin: 0 auto;
  padding: 0.2rem 0;
}
.pc-input {
  width: 100%;
  height: 1.2rem;
  font-size: 0.4rem;
  text-align: center;
  border: 0.02rem solid #ebedf0;
  border-radius: 0.1rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
}
.pc-input:focus {
  outline: none;
  border-color: #5b60df;
}
</style>
